import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material';
import { BentoThemeProvider } from '@zenput/ui-bento';

interface DeleteFollowUpActionModalProps {
    handleCloseConfirmation: () => void;
    onSubmit: () => void;
    showConfirmation: boolean;
}

export const DeleteFollowUpActionModal = (props: DeleteFollowUpActionModalProps) => {
    const { handleCloseConfirmation, onSubmit, showConfirmation } = props;

    return (
        <BentoThemeProvider>
            <Dialog open={showConfirmation} onClose={handleCloseConfirmation}>
                <DialogTitle>{_t('mobile_mobileform_add_follow_up_actions_forms_delete_modal_title')}</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ whiteSpace: 'pre-wrap' }}>
                        {_t('mobile_mobileform_add_follow_up_actions_forms_delete_modal_subtitle')}
                    </DialogContentText>
                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent: 'center'
                    }}
                >
                    <Stack
                        sx={{
                            width: '100%'
                        }}
                        gap={2}
                    >
                        <Button variant="contained" color="error" onClick={onSubmit}>
                            {_t('mobile_drafts_button_delete')}
                        </Button>
                        <Button variant="text" onClick={handleCloseConfirmation}>
                            {_t('mobile_action_sheet_cancel')}
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>
        </BentoThemeProvider>
    );
};
